<template>
  <div class="gun-table">

    <!-- TABLEAU AFFICHAGE -->
      <b-table-simple hover small caption-top responsive class="pt-3" v-if="gunParcData">
        <b-thead variant="dark">
          <b-tr>
            <b-th></b-th>
            <b-th>Données OREOL</b-th>
            <b-th>Données GUN</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr>
            <b-td>Nom du parc</b-td>
            <b-td>
              <span v-if="parc.nomUsuel">{{ parc.nomUsuel }}</span>
              <span v-else>{{ emptyField }}</span>
            </b-td>
            <b-td>
              <span v-if="gunParcData.raisonSociale">{{ gunParcData.raisonSociale }}</span>
              <span v-else>{{ emptyField }}</span>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <b-form class="parc-form pt-2 px-md-3">
        <!-- Mail -->
        <b-form-group
          label-cols-lg="3"
          label="Signalement de données incorrectes"
          label-size="lg"
          label-class="fw-bold pt-0"
          class="mb-0"
        >
          <b-form-group
            id="input-group-mail"
            label="Destinataire"
            label-for="input-mail"
            description="Service destinaire de la notification"
          >
            <b-form-input
              id="input-mail"
              v-model="form.mail"
              type="text"
              required
              placeholder="Saisir le mail"
              readonly
            ></b-form-input>
          </b-form-group>

           <b-form-group
            id="input-group-text"
            label="Demande"
            label-for="input-text"
            description="Demande de modification à apporter sur GUN"
          >
             <b-form-textarea
               id="input-text"
               v-model="form.text"
               required
               style="height: 12rem"
             ></b-form-textarea>
          </b-form-group>
        </b-form-group>
        <b-button
          variant="info"
          id="envoyer"
          style="float: right"
        >
          Envoyer
          <b-tooltip target="#envoyer">
            Notifier la DREAL
          </b-tooltip>
        </b-button>
      </b-form>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  BTableSimple,
  BThead,
  BTr,
  BTh,
  BTbody,
  BTd,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BButton, BForm, BTooltip
} from "bootstrap-vue-next";

export default {
  components: {
    BTooltip,
    BTableSimple,
    BThead, BTr, BTh,
    BTbody, BTd,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    BForm,
  },
  data() {
    return {
      emptyField: "-",
      form : {
        mail :'',
        text : ''
        }
    };
  },
  created(){
    this.form.mail = this.parc.equipeDreal.libelle
    this.form.text = "Bonjour,\n\nLes données présentes dans Gun sont différentes des données déclarées dans Oreol pour le parc "+this.parc.id+".\n\nNom du parc : \n\n Oreol : "+ this.parc.nomUsuel+" \n\n Gun : "+ this.gunParcData.raisonSociale+"\n\nCordialement, \n\n"+ this.user.name

  },
  computed: {
    ...mapGetters({
      parc: "parc",
      gunParcData: "gunParcData",
      user: "user"
    }),
  }
};
</script>

<style lang="scss">
.gun-table {
  table > * {
    font-size: 0.9em !important;
    text-align: center;
  }

  table {
    tr {
      td:first-of-type, th:first-of-type{
        width: 200px;
        text-transform: uppercase;
      }
    }
  }
}
</style>
